import { FormDropdown } from '@portal_components/components/FormDropdown';
import { FormCard } from '@portal_components/components/FormCard';
import { MeterPointDetails } from '../../types';

interface SiteInvoiceDetailsProps {
  invoices: { title: string; value: string }[] | undefined;
  invoicesLoading: boolean;
  readonly: boolean;
}

export const SiteInvoiceDetailsTab = ({ invoices, invoicesLoading, readonly }: SiteInvoiceDetailsProps) => {
  if (invoicesLoading) {
    return <div className="flex flex-row justify-center">Loading invoices...</div>;
  }

  if (!invoices || invoices.length === 0) {
    return <div className="flex flex-row justify-center">No invoices associated to customer or contract</div>;
  }

  return (
    <FormCard>
      <FormDropdown<MeterPointDetails>
        title="Invoice"
        name="invoiceGroupId"
        placeholder="Select Invoice"
        elementsForDisplay={invoices}
        readonly={readonly}
      />
    </FormCard>
  );
};
